// esilnt-disable
import { createRouter, createWebHistory } from "vue-router";
import store from "../store";
import middlewarePipeline from "../../middleware-pipeline";
import auth from "@/middleware/auth.js";
import metaTitle from "@/middleware/metaTitle.js";
import { AppCodes } from "@/utils/constants";
import { handleRouting } from "../utils/constants";

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => <div></div>,
    meta: {
      title: "Login - Matta Trade",

      metaTags: [
        {
          name: "description",
          content: "Login in Matta account",
        },
        {
          property: "og:description",
          content: "Login in Matta account",
        },
      ],
    },
    beforeEnter: () => {
      if (store.getters.isLoggedIn) {
        return { name: "admin" };
      } else {
        handleRouting();
      }
    },
  },
  {
    path: "/invited-user/:id",
    name: "register invited user",
    component: () =>
      import(
        /* webpackChunkName: "InvitedUser" */ "../views/auth/InvitedUser.vue"
      ),
    meta: {
      title: "Invited User - Matta Trade",
      metaTags: [
        {
          name: "description",
          content: "Invited User in Matta account",
        },
        {
          property: "og:description",
          content: "Invited User in Matta account",
        },
      ],
    },
    beforeEnter: () => {
      if (store.getters.isLoggedIn) {
        return { name: "admin" };
      }
    },
  },
  {
    path: "/register/:type",
    name: "register",
    component: () =>
      import(
        /* webpackChunkName: "Register" */ "../views/auth/RegisterView.vue"
      ),
    meta: {
      title: "Register - Matta Trade",
      metaTags: [
        {
          name: "description",
          content: "Register on matta",
        },
        {
          property: "og:description",
          content: "Register on matta",
        },
      ],
    },
    beforeEnter: () => {
      if (store.getters.isLoggedIn) {
        return { name: "admin" };
      } else {
        handleRouting();
      }
    },
  },
  {
    path: "/auth/validate",
    name: "AuthValidate",
    component: () =>
      import(
        /* webpackChunkName: "AuthValidate" */ "../views/auth/Validate.vue"
      ),
    meta: {
      title: "Auth Validate - Matta Trade",
      metaTags: [
        {
          name: "description",
          content: "Auth Validate.",
        },
        {
          property: "og:description",
          content: "Auth Validate.",
        },
      ],
    },
  },

  {
    path: "/",
    name: "admin",
    component: () =>
      import(/* webpackChunkName: "Flux" */ "../views/flux/index.vue"),
    children: [
      {
        path: "",
        name: "Flux dashboard index",
        component: () =>
          import(
            /* webpackChunkName: "FluxdashboardAdmin" */ "@/components/admin/dashboard/index.vue"
          ),
        meta: {
          title: "Dashboard",
          roles: [
            "superadmin",
            "superuser",
            "admin",
            "sales",
            "commercial",
            "finance",
            "agent",
          ],
          metaTags: [
            {
              name: "description",
              content: "overview page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "overview page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "Storefront",
              url: "#",
            },
            {
              name: "overview",
              url: "#",
            },
          ],
          appIds: [AppCodes.flux],
          requiresAuth: true,
        },
      },
      {
        path: "configuration",
        name: "Configuration",
        component: () =>
          import(
            /* webpackChunkName: "FluxdashboardAdmin" */ "@/components/flux/Management/Configuration/index.vue"
          ),
        meta: {
          title: "Configuration",
          roles: [
            "superadmin",
            "superuser",
            "admin",
            "sales",
            "commercial",
            "finance",
            "agent",
          ],
          metaTags: [
            {
              name: "description",
              content: "overview page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "overview page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "Storefront",
              url: "#",
            },
            {
              name: "overview",
              url: "#",
            },
          ],
          appIds: [AppCodes.flux],
          requiresAuth: true,
        },
      },
      {
        path: "quote-requests",
        name: "Quote Requests",
        component: () =>
          import(
            /* webpackChunkName: "FluxdashboardAdmin" */ "@/components/flux/Management/QuoteRequests/index.vue"
          ),
        meta: {
          title: "Quote Requests",
          roles: [
            "superadmin",
            "superuser",
            "admin",
            "sales",
            "commercial",
            "finance",
            "agent",
          ],
          metaTags: [
            {
              name: "description",
              content: "overview page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "overview page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "Storefront",
              url: "#",
            },
            {
              name: "overview",
              url: "#",
            },
          ],
          appIds: [AppCodes.flux],
          requiresAuth: true,
        },
      },
      {
        path: "dashboard",
        name: "Flux dashboard",
        component: () =>
          import(
            /* webpackChunkName: "FluxAdmin" */ "@/components/admin/dashboard/index.vue"
          ),
        meta: {
          title: "Dashboard",
          roles: [
            "superadmin",
            "superuser",
            "admin",
            "sales",
            "commercial",
            "finance",
            "agent",
          ],
          metaTags: [
            {
              name: "description",
              content: "overview page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "overview page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "Storefront",
              url: "#",
            },
            {
              name: "overview",
              url: "#",
            },
          ],
          appIds: [AppCodes.flux],
          requiresAuth: true,
        },
      },
      {
        path: "drivers-management",
        name: "Flux drivers",
        component: () =>
          import(
            /* webpackChunkName: "FluxDrivers" */ "../views/flux/Drivers.vue"
          ),
        meta: {
          title: "Drivers",
          roles: [
            "superadmin",
            "superuser",
            "admin",
            "sales",
            "commercial",
            "finance",
            "agent",
          ],
          metaTags: [
            {
              name: "description",
              content: "metrics page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "metrics page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "dashboard",
              url: "#",
            },
            {
              name: "metrics",
              url: "#",
            },
          ],
          appIds: [AppCodes.flux],
        },
      },
      {
        path: "vehicles-management",
        name: "Flux Vehicles",
        component: () =>
          import(
            /* webpackChunkName: "FluxVehicles" */ "../views/flux/Vehicles.vue"
          ),
        meta: {
          title: "Vehicles",
          roles: [
            "superadmin",
            "superuser",
            "admin",
            "sales",
            "commercial",
            "finance",
            "agent",
          ],
          metaTags: [
            {
              name: "description",
              content: "Settings page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "Settings page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "Account",
              url: "#",
            },
            {
              name: "Settings",
              url: "#",
            },
          ],
          appIds: [AppCodes.flux],
        },
      },
      {
        path: "vehicles-management/add-vehicle",
        name: "Flux Add Vehicles",
        component: () =>
          import(
            /* webpackChunkName: "FluxAddVehicles" */ "../views/flux/AddVehicle.vue"
          ),
        meta: {
          title: "Vehicles",
          roles: [
            "superadmin",
            "superuser",
            "admin",
            "sales",
            "commercial",
            "finance",
            "agent",
          ],
          metaTags: [
            {
              name: "description",
              content: "Settings page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "Settings page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "Account",
              url: "#",
            },
            {
              name: "Settings",
              url: "#",
            },
          ],
          appIds: [AppCodes.flux],
        },
      },
      {
        path: "vehicles-management/edit-vehicle/:id",
        name: "Flux Edit Vehicles",
        component: () =>
          import(
            /* webpackChunkName: "FluxAddVehicles" */ "../views/flux/EditVehicle.vue"
          ),
        meta: {
          title: "Vehicles",
          roles: [
            "superadmin",
            "superuser",
            "admin",
            "sales",
            "commercial",
            "finance",
            "agent",
          ],
          metaTags: [
            {
              name: "description",
              content: "Settings page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "Settings page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "Account",
              url: "#",
            },
            {
              name: "Settings",
              url: "#",
            },
          ],
          appIds: [AppCodes.flux],
        },
      },
      {
        path: "orders-management",
        name: "Flux Orders",
        component: () =>
          import(
            /* webpackChunkName: "Fluxorders" */ "../views/flux/Orders.vue"
          ),
        meta: {
          title: "Orders",
          roles: ["superadmin", "superuser", "admin"],
          allowed: ["CompanyAdmin"],
          metaTags: [
            {
              name: "description",
              content: "Administrators page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "Administrators page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "overview",
              url: "/",
            },

            {
              name: "Administrators",
              url: "#",
            },
          ],
          middleware: [auth, metaTitle],
          appIds: [AppCodes.flux],
        },
      },
      {
        path: "bids-management/:id",
        name: "Flux Bids",
        component: () =>
          import(/* webpackChunkName: "FluxBids" */ "../views/flux/Bids.vue"),
        meta: {
          title: "Bids",
          roles: ["superadmin", "superuser", "admin"],
          allowed: ["CompanyAdmin"],
          metaTags: [
            {
              name: "description",
              content: "Administrators page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "Administrators page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "overview",
              url: "/",
            },

            {
              name: "Administrators",
              url: "#",
            },
          ],
          middleware: [auth, metaTitle],
          appIds: [AppCodes.flux],
        },
      },
      {
        path: "payments-management",
        name: "Flux Payments",
        component: () =>
          import(
            /* webpackChunkName: "PaymentsManagement" */ "../views/flux/Payments.vue"
          ),
        meta: {
          title: "Payments",
          roles: ["superadmin", "superuser", "admin"],
          allowed: ["CompanyAdmin"],
          metaTags: [
            {
              name: "description",
              content: "Administrators page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "Administrators page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "overview",
              url: "/",
            },

            {
              name: "Administrators",
              url: "#",
            },
          ],
          middleware: [auth, metaTitle],
          appIds: [AppCodes.flux],
        },
      },
      {
        path: "users-management",
        name: "Flux Users",
        component: () =>
          import(/* webpackChunkName: "FluxUsers" */ "../views/flux/Users.vue"),
        meta: {
          title: "Users",
          roles: ["superadmin", "superuser", "admin"],
          allowed: ["CompanyAdmin"],
          metaTags: [
            {
              name: "description",
              content: "Administrators page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "Administrators page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "overview",
              url: "/",
            },

            {
              name: "Administrators",
              url: "#",
            },
          ],
          middleware: [auth, metaTitle],
          appIds: [AppCodes.flux],
        },
      },
      {
        path: "administrators",
        name: "Flux administrators",
        component: () =>
          import(
            /* webpackChunkName: "FluxAdministrators" */ "../views/flux/Administrators.vue"
          ),
        meta: {
          title: "Flux Administrators",
          roles: [
            "superadmin",
            "superuser",
            "admin",
            "sales",
            "commercial",
            "finance",
            "agent",
          ],
          metaTags: [
            {
              name: "description",
              content: "Settings page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "Settings page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "Account",
              url: "#",
            },
            {
              name: "Settings",
              url: "#",
            },
          ],
          appIds: [AppCodes.flux],
        },
      },
      {
        path: "vendor-customers/:name/:id",
        name: "Flux Vendor Customers",
        component: () =>
          import(
            /* webpackChunkName: "VendorCustomers" */ "../views/flux/VendorCustomers.vue"
          ),
        meta: {
          title: "Vendors Customers",
          roles: ["superadmin", "superuser", "admin"],
          allowed: ["CompanyAdmin"],
          metaTags: [
            {
              name: "description",
              content: "Administrators page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "Administrators page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "overview",
              url: "/",
            },

            {
              name: "Administrators",
              url: "#",
            },
          ],
          middleware: [auth, metaTitle],
          appIds: [AppCodes.flux],
        },
      },
    ],
    meta: {
      title: "Admin Dashboard - Matta Trade",
      metaTags: [
        {
          name: "description",
          content: "Admin Dashboard page of Matta Trade.",
        },
        {
          property: "og:description",
          content: "Admin Dashboard page Matta Trade.",
        },
      ],
      requiresAuth: true,
      isAdminRoute: true,
      middleware: [auth, metaTitle],
      appIds: [AppCodes.flux],
    },
  },
  {
    path: "/:catchAll(.*)",
    name: "Not found",
    component: () =>
      import(/* webpackChunkName: "notfound" */ "../views/NotFound.vue"),
  },
];
const scrollBehavior = (to, from, savedPosition) => {
  return savedPosition || { top: 0, left: 0 };
};
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior,
});

router.beforeEach((to, from, next) => {
  // Collect middleware from all matched records (parent → child) and deduplicate
  const middleware = to.matched
    .flatMap((record) => record.meta.middleware ?? [])
    .filter((fn, idx, arr) => arr.indexOf(fn) === idx);

  if (!middleware.length) {
    return next();
  }

  const context = { to, from, next, store };

  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1),
  });
});
export default router;
